/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Core_Desc4Inputs */

const en_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth, database and the one workflow that makes the product valuable.`)
};

const ar_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المصادقة وقاعدة البيانات وسير العمل الوحيد الذي يجعل المنتج قيما.`)
};

const bn_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অথ, ডেটাবেস আর সেই এক ওয়ার্কফ্লো যা প্রোডাক্টকে মূল্যবান করে।`)
};

const de_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth, Datenbank und der eine Workflow, der das Produkt wertvoll macht.`)
};

const es_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticación, base de datos y el único flujo que hace valioso el producto.`)
};

const fr_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification, base de données et l'unique flux qui rend le produit précieux.`)
};

const pt_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticação, base de dados e o único fluxo que torna o produto valioso.`)
};

const zh_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录、数据库，以及让产品真正有价值的那一个工作流。`)
};

const tr_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimlik doğrulama, veritabanı ve ürünü değerli kılan tek akış.`)
};

const ru_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Авторизация, база данных и тот единственный флоу, который делает продукт ценным.`)
};

const pl_svc_mvp_sprint_core_desc4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie, baza danych i ten jeden przepływ, który czyni produkt wartościowym.`)
};

/**
* | output |
* | --- |
* | "Auth, database and the one workflow that makes the product valuable." |
*
* @param {Svc_Mvp_Sprint_Core_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_core_desc4 = /** @type {((inputs?: Svc_Mvp_Sprint_Core_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Core_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_core_desc4(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_core_desc4(inputs)
	if (locale === "de") return de_svc_mvp_sprint_core_desc4(inputs)
	if (locale === "es") return es_svc_mvp_sprint_core_desc4(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_core_desc4(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_core_desc4(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_core_desc4(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_core_desc4(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_core_desc4(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_core_desc4(inputs)
	return en_svc_mvp_sprint_core_desc4(inputs)
});
export { svc_mvp_sprint_core_desc4 as "svc_mvp-sprint_CORE_desc" }